import React from "react";
import { Link, useLocation } from "react-router-dom";
import { DropdownMenu } from "reactstrap";
import Swal from "sweetalert2";
const CandidateUserDropdown = ({ onLogout, toggleUserDropdown }) => {
  const { pathname } = useLocation();

  // Logout confirmation logic
  const handleLogoutClick = (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to logout from your account?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Logout!",
      cancelButtonText: "Cancel",
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        // 1. Clear everything from storage
        localStorage.removeItem("webvi_authToken");
        localStorage.removeItem("jobseekerspage_userId");
        localStorage.removeItem("webvi_userInfo");
        localStorage.removeItem("jobseekerspage_redirect_url");

        // 2. Call the logout function to clear Redux
        onLogout();

        // 3. Instead of navigate("/"), use this to force the UI to reset
        window.location.href = "/";
      }
    });
  };

  return (
    <DropdownMenu
      className="dropdown-menu-end cust-dropdown"
      aria-labelledby="userdropdown"
      end
    >
      <li>
        <Link
          className={`dropdown-item ${pathname === "/candidate/dashboard" ? "active" : ""
            } `}
          onClick={toggleUserDropdown}
          to="/candidate/dashboard"
        >
          DashBoard
        </Link>
      </li>

      <li>
        <Link
          className={`dropdown-item ${pathname === "/candidate/job/application/manage" ? "active" : ""
            } `}
          onClick={toggleUserDropdown}
          to="/candidate/job/application/manage"
        >
          Job Applications
        </Link>
      </li>
      <li>
        <Link
          className={`dropdown-item ${pathname === "/candidate/job/bookmark/manage" ? "active" : ""
            } `}
          onClick={toggleUserDropdown}
          to="/candidate/job/bookmark/manage"
        >
          Bookmarked Jobs
        </Link>
      </li>
      <li>
        <Link
          className={`dropdown-item ${pathname === "/candidate/profile/view" ? "active" : ""
            } `}
          onClick={toggleUserDropdown}
          to="/candidate/profile/view"
        >
          My Profile
        </Link>
      </li>
      <li>
        <Link
          className={`dropdown-item ${pathname === "/jobs" ? "active" : ""
            } `}
          onClick={toggleUserDropdown}
          to="/jobs"
        >
          Explore Jobs
        </Link>
      </li>
      <li>
        {/* Logout Link with SweetAlert logic */}
        <Link className={`dropdown-item`} to="/" onClick={handleLogoutClick}>
          Logout
        </Link>
      </li>
    </DropdownMenu>
  );
};

export default CandidateUserDropdown;
